<form [formGroup]="formGroup" class="flex flex-row gap-[0.5rem] items-center">
  <p-toggleswitch class="flex" formControlName="thresholdColor" />

  <div class="flex flex-row items-end gap-[0.125rem] h-[0.875rem]">
    <div class="w-[0.25rem] h-[0.625rem] rounded-[0.0625rem]" [style.background-color]="warningColor"></div>
    <div class="w-[0.25rem] h-[0.9375rem] rounded-[0.0625rem]" [style.background-color]="criticalColor"></div>
    <div class="w-[0.25rem] h-[0.375rem] rounded-[0.0625rem]" [style.background-color]="positiveColor"></div>
  </div>

  @let isScreenMdUp = scrRes.isScreenMdUp();
  @let isLabelVisible = !isLabelHidden();

  @if (isScreenMdUp && isLabelVisible) {
    <div
      class="text-[0.6875rem] font-[500] leading-[150%] text-(--p-primary-500) whitespace-nowrap"
      translate="@@floating-popup-chart-threshold-color__label">
    </div>
  }
  
</form>
